import { DateTime } from 'luxon';
import type { OrganisationJson } from '@/api/model/Organisation';
import { Organisation } from '@/api/model/Organisation';

export interface UserJson {
    public_id: string;
    email: string;
    name: string;
    profile_picture: string;
    created_at: string;
    updated_at: string;
    email_verified_at: string;
    organisations: OrganisationJson[];
    roles: string[];
    is_super_admin: boolean;
}

export class User {
    public_id = '';
    email = 'Unknown';
    name = 'Unknown';
    profile_picture = 'Unknown';
    created_at: DateTime = DateTime.now();
    updated_at: DateTime = DateTime.now();
    email_verified_at: DateTime = DateTime.now();
    organisations: Organisation[] = [];
    roles: string[] = [];
    is_super_admin = false;

    static fromJSON(json: UserJson): User {
        //console.debug("User.fromJSON()", json);
        const user = Object.create(User.prototype);
        return Object.assign(user, json, {
            created_at: json.created_at ? DateTime.fromISO(json.created_at) : DateTime.now(),
            updated_at: json.updated_at ? DateTime.fromISO(json.updated_at) : DateTime.now(),
            email_verified_at: json.email_verified_at ? DateTime.fromISO(json.email_verified_at) : null,
            organisations: json.organisations?.map((org: OrganisationJson) => Organisation.fromJSON(org)),
            roles: json.roles ?? [],
            is_super_admin: json.is_super_admin ?? false,
        });
    }

    static mock({ name = 'Test User', email = 'test@example.com', ...overrides }: Partial<User> = {}): User {
        return Object.assign(
            new User(),
            {
                public_id: 'usr_mock0000001',
                name,
                email,
                profile_picture: '',
                created_at: DateTime.now(),
                updated_at: DateTime.now(),
                email_verified_at: null,
                organisations: [],
            },
            overrides,
        );
    }
}
